<template>
    <figure class="mb-2">
        <audio :controls="showControls" :src="strAudioLink" class="call-audio mt-2" :key="audioKey"></audio>
        <a v-if="showDownload" class="a-dwld" :href="strAudioLink" download><i class="d-inline-block tim-icons icon-cloud-download-93"></i></a>
        <a v-if="showRefresh" class="a-refresh" @click="ReloadCall()"><i class="d-inline-block tim-icons icon-refresh-01"></i></a>
    </figure>
</template>

<script>
export default {
  name: "AudioPlayer",
  props: {
    // Ссылка на аудиозапись
    record: {
      type: String,
      required: true,
    },
    // Показывать ли элементы управления
    showControls: {
      type: Boolean,
      default: true,
    },
    // Показывать ли кнопку скачивания
    showDownload: {
      type: Boolean,
      default: true,
    },
    // Показывать ли кнопку обновления
    showRefresh: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      audioKey: 0, // Уникальный ключ для аудио
    };
  },
  computed: {
    // Добавляем случайное число к ссылке для предотвращения кэширования
    strAudioLink() {
        // Проверяем, заканчивается ли ссылка на .mp3
        const hasMp3Extension = this.record.length >= 4 && this.record.slice(-4).toLowerCase() === '.mp3';

        // Формируем базовую ссылку с расширением, если оно отсутствует
        const baseLink = hasMp3Extension ? this.record : `${this.record}.mp3`;

        // Добавляем случайный параметр для предотвращения кэширования
        const randomParam = `?rand=${Math.random().toString(36).substr(2, 9)}`;
        return baseLink + randomParam;
    }
  },
  methods: {
    // Метод для обновления аудио
    ReloadCall() {
      this.$emit('reload');
      /*
      this.$GVO.ApiCall("RELOAD_REC", {
        obj: "PhoneCallApi",
        flt: { link: this.record },
      })
        .then((objApi) => {
          if (objApi.success) {
            const newRecord = `/DATA/PhoneRec/${objApi.data.file_path}`;

            // Уведомляем родительский компонент о новой ссылке
            this.$emit("update-record", newRecord);
            this.audioKey += 1;
          }
        })
        .catch((errorObjApi) => {
          console.log(errorObjApi);
        });
      */
    },    
  },
};
</script>
<style scoped>
    figure > *{display: inline-block;}
    figure > a.a-dwld, figure > a.a-refresh{
        font-size: 35px;
        vertical-align: top;
        margin-top: 10px;
        margin-left: 20px;
        cursor: pointer;
    }
    a.a-refresh{color: #9e77f3;}
    a.a-refresh:hover{color: #01B0E0;}
</style>